import React from "react";
import { Button, Typography, Space, Divider } from "antd";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";

export default function Terms() {
  const navigate = useNavigate();
  const { Title, Text, Paragraph } = Typography;

  return (
    <>
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Button
            type="text"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(-1)}
            style={{ padding: 0 }}
          />
          <Title level={3} style={{ margin: 0 }}>
            Termos e Condições de Uso
          </Title>
        </div>

        <div>
          <Space direction="vertical" size="middle" style={{ width: "100%" }}>
            <Paragraph>
              <Text strong>Última atualização:</Text>{" "}
              {new Date().toLocaleDateString("pt-BR")}
            </Paragraph>

            <section>
              <Title level={4}>1. Aceitação dos Termos</Title>
              <Paragraph>
                Ao acessar e usar esta plataforma, você aceita estar vinculado a
                estes Termos e Condições de Uso. Se você não concordar com
                qualquer parte destes termos, não poderá usar nossos serviços.
              </Paragraph>
            </section>

            <section>
              <Title level={4}>2. Uso da Plataforma</Title>
              <Paragraph>
                Você concorda em usar esta plataforma apenas para fins legítimos
                e de acordo com todas as leis e regulamentos aplicáveis. Você é
                responsável por garantir que seu uso não seja ilegal ou
                proibido.
              </Paragraph>
            </section>

            <section>
              <Title level={4}>3. Cadastro e Segurança da Conta</Title>
              <Paragraph>
                Ao se cadastrar, você concorda em fornecer informações
                verdadeiras, precisas e completas. Você é responsável por manter
                a confidencialidade de sua senha e por todas as atividades que
                ocorram em sua conta.
              </Paragraph>
            </section>

            <section>
              <Title level={4}>4. Propriedade Intelectual</Title>
              <Paragraph>
                Todo o conteúdo, recursos e funcionalidades da plataforma são de
                propriedade exclusiva e estão protegidos por leis de propriedade
                intelectual. Você concorda em não copiar, modificar, distribuir
                ou criar trabalhos derivados sem permissão expressa.
              </Paragraph>
            </section>

            <section>
              <Title level={4}>5. Privacidade e Proteção de Dados</Title>
              <Paragraph>
                Nós valorizamos sua privacidade e estamos comprometidos em
                proteger seus dados pessoais. Nossa Política de Privacidade
                descreve como coletamos, usamos e protegemos suas informações.
              </Paragraph>
            </section>

            <section>
              <Title level={4}>6. Limitação de Responsabilidade</Title>
              <Paragraph>
                A plataforma é fornecida "no estado em que se encontra". Não nos
                responsabilizamos por quaisquer danos diretos, indiretos,
                incidentais ou consequenciais resultantes do uso ou incapacidade
                de uso da plataforma.
              </Paragraph>
            </section>

            <section>
              <Title level={4}>7. Modificações nos Termos</Title>
              <Paragraph>
                Reservamo-nos o direito de modificar estes termos a qualquer
                momento. As alterações serão efetivas imediatamente após a
                publicação na plataforma. Seu uso contínuo após as alterações
                constitui aceitação dos novos termos.
              </Paragraph>
            </section>

            <section>
              <Title level={4}>8. Rescisão</Title>
              <Paragraph>
                Podemos rescindir ou suspender seu acesso à plataforma
                imediatamente, sem aviso prévio, por qualquer motivo, incluindo
                violação destes Termos e Condições.
              </Paragraph>
            </section>

            <section>
              <Title level={4}>9. Lei Aplicável</Title>
              <Paragraph>
                Estes Termos e Condições serão regidos e interpretados de acordo
                com as leis do Brasil. Qualquer disputa será resolvida nos
                tribunais competentes.
              </Paragraph>
            </section>

            <section>
              <Title level={4}>10. Contato</Title>
              <Paragraph>
                Se você tiver dúvidas sobre estes Termos e Condições, entre em
                contato conosco através dos canais de suporte disponíveis na
                plataforma.
              </Paragraph>
            </section>

            <Divider />

            <Text type="secondary" style={{ fontSize: "12px" }}>
              Ao clicar em "Aceito os Termos e Condições" durante o cadastro,
              você confirma que leu, compreendeu e concorda em estar legalmente
              vinculado a estes termos.
            </Text>
          </Space>
        </div>
      </Space>
    </>
  );
}
